export default "__VITE_ASSET__DvXLJr5n__"